(function ($) {
    'use strict'

    $(document).ready(function () {
        svg4everybody({})


        const header = document.querySelector(".headroom");

        const headroom = new Headroom(header);
        headroom.init();


        $('#timer').countdown($('#timer').data('date'), function (event) {
            var $this = $(this).html(event.strftime(''
                + '<div class="time-js" > <span>%D</span></div> :'
                + '<div class="time-js" > <span>%H</span></div> :'
                + '<div class="time-js" > <span>%M</span></div> :'
                + '<div class="time-js" > <span>%S</span></div>'));
        });

        $('.rating-click > a').on('click', function (e) {
            e.preventDefault()
            var value = $(this).attr('value')
            $(this).addClass('active')
            $(this).prevAll().addClass('active')
            $(this).nextAll().removeClass('active')
            $('.rating-click input').val(value)
        });

        var params = 'all-scroll';
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            var params = 'iphone-scroll'
        }

        $(".search-content__product").niceScroll({
            cursorcolor: "#B1C962",
            cursorwidth: "11px",
            cursoropacitymin: 1,
        });

        $(".products__left form").niceScroll({
            cursorcolor: "#B1C962",
            cursorwidth: "8px",
            cursoropacitymin: 1,
            enableobserver: true
        });
        $(".products__left form").scroll(function () {
            $(".products__left form").getNiceScroll().resize();
        });


        $('.town').styler({
            selectSearch: true,
            selectSearchLimit: 0,
        });

        $(".js-select2").select2({
            placeholder: "Select a state",
        });

        // var placeScroll = document.getElementById('scroll');
        // if (placeScroll) {
        //     new SimpleBar(document.getElementById('scroll'), {
        //         autoHide: false,
        //     });
        // }
        $(document).scroll(function () {
            var basket = document.getElementById('basket');
            if (basket) {

                var order = $('.basket__order-wrapper').offset().top;
                var wind = $(this).scrollTop()
                // console.log(order, wind)
                if ($(window).width() > 1179 && wind >= order) {
                    $('.basket__info').addClass('active')
                } else {
                    $('.basket__info').removeClass('active')
                }
            }
        })


        $('.basket__feedback a').on('click', function () {
            $('.feedback-toggle').slideToggle();
        })

        // $('.form-group_town .select2').on('click', function () {
        //     $('.select2-selection__arrow').addClass('active')
        // })

        // $(document).mouseup(function (e) {
        //     var $div = $('.header__menu, .mobile');
        //     if (!$div.is(e.target) && $div.has(e.target).length === 0) {
        //         $('.select2-selection__arrow').removeClass('active')

        //     }
        // });

        $('.header__logo .mobile').on('click', function () {
            $('.header__logo .mobile').toggleClass('active')
            // $('.header__logo').toggleClass('active')
            $('.header__menu').toggleClass('active')
            $('html,body').toggleClass(params)
        })

        $('.label').on('click', function () {
            $('.basket__tab-content').removeClass('active')
            $(this).parent().addClass('active')
        })

        $('.pay').on('click', function () {
            $('.pay').removeClass('active')
            $(this).addClass('active')
        })

        if ($(window).width() <= 768) {
            $('.click-sort').on('click', function () {
                $('.products__left').addClass('active')
                $('.products__wrapper').addClass('active')
                $('.products__items').addClass('active')
            })

            $('.click-sort').on('click', function () {
                $('body,html').addClass(params)
            })


            $('.products__left-close').on('click', function () {
                $('.products__left').removeClass('active')
                $('.products__wrapper').removeClass('active')
                $('.products__items').removeClass('active')
                $('html,body').removeClass(params)
            })

            // $(document).mouseup(function (e) {
            //     var $div = $('.header__menu, .mobile, .products__left, .search-content__input');
            //     if (!$div.is(e.target) && $div.has(e.target).length === 0) {
            //         $('.header__logo .mobile').removeClass('active')
            //         $('.header__menu').removeClass('active')
            //         $('html,body').removeClass(params)
            //     }
            // });

            // $(document).mouseup(function (e) {
            //     var $div = $('.products__left, .search-content');
            //     if (!$div.is(e.target) && $div.has(e.target).length === 0) {
            //         $('.products__left').removeClass('active')
            //         $('.products__wrapper').removeClass('active')
            //         $('.products__items').removeClass('active')
            //     }
            // });
        }
        if ($(window).width() > 767) {
            // $('.products__left').addClass('active')
            $('.products__wrapper').addClass('active')
        }

        $('.products__filter-item__title').on('click', function () {
            $(this).parent().children('.products__filter-content').slideToggle();
            $(this).toggleClass('active');
        })

        $('.preventDefault, .form-group__button').on('click', function (e) {
            e.preventDefault()
        })

        $('.form-group__button').on('click', function () {
            $(this).toggleClass('active');
            if ($(this).hasClass('active')) {
                $(this).parent().children('.password').attr('type', 'text')
            } else {
                $(this).parent().children('.password').attr('type', 'password')
            }
        })

        $('.collapse-link').on('mouseover', function () {
            $('.collapse-link').removeClass('active')
            $(this).addClass('active')
        })
        $('.collapse-link').on('mouseout', function () {
            $('.collapse-link').removeClass('active')
        })

        $('.search').on('click', function () {
            $('.search-content').addClass('active')
            setTimeout(function () {
                if ($('.search-content').hasClass('active')) {
                    $(".search-content__input input").focus()
                }
            }, 500);
            $('html,body').addClass(params)
        })
        $('.close-search').on('click', function () {
            $('.search-content').removeClass('active')
            $('html,body').removeClass(params)
        })

        $('.history__item').on('click', function () {
            if ($(this).parent().children('.history__content-detail').hasClass('show')) {
                $(this).toggleClass('active')
            }
            else {
                $('.history__item').removeClass('active')
                $(this).addClass('active')
            }
        })

        // $('.up-btn').on('click', function () {
        //     $('body,html').animate({
        //         scrollTop: 0
        //     }, 800)
        // })

        // $(window).scroll(function () {
        //     if ($(this).scrollTop() > 150) {
        //         $('.up-btn').addClass('active')
        //     } else {
        //         $('.up-btn').removeClass('active')

        //     }
        // })


        var swiper = new Swiper('.slider-main', {
            slidesPerView: 'auto',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });


        var swiper5 = new Swiper('.recomended-slider', {
            slidesPerView: 'auto',
        });


        var swiper3 = new Swiper('.slider-feedback', {
            slidesPerView: 'auto',
            observer: true,
            observeParents: true,
            mousewheel: {
                sensitivity: 5,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
        });

        var homeSwiper = new Swiper("#homeSwiper", {
            slidesPerView: 4,
            spaceBetween: 40
        });

        if ($(window).width() < 1180) {
            var swiper2 = new Swiper('.slider-discount', {
                slidesPerView: 'auto',
            })
        }
    })
})(jQuery);

(function ($) {
    'use strict'
    $(document).ready(function () {
        svg4everybody({})

        var url = location.href,
            fb = 'http://www.facebook.com/sharer.php?u=',
            inst = 'http://www.instagram.com/sharer.php?u=',
            vk = 'http://vk.com/share.php?url=',
            tw = 'https://twitter.com/share?url=',
            tel = 'https://t.me/share/url?url=',
            goog = 'https://plus.google.com/share?url=',
            ln = 'https://www.linkedin.com/shareArticle?mini=true&url=',
            ok = 'https://www.ok.ru/dk?st.cmd=addShare&st.s=1&st._surl=';

        function openWin(sharemedia) {
            myWin = open(sharemedia + url, "displayWindow", "width=520,height=300,left=350,top=170,status=no,toolbar=no,menubar=no");
        };

        $(document).on('click', '.shared-block .vk-share', function (e) {
            e.preventDefault();
            openWin(vk);
        });
        $(document).on('click', '.shared-block .inst-share', function (e) {
            e.preventDefault();
            openWin(inst);
        });

        $(document).on('click', '.shared-block .fb-share', function (e) {
            e.preventDefault();
            openWin(fb);
        });

        $(document).on('click', '.shared-block .tw-share', function (e) {
            e.preventDefault();
            openWin(tw);
        });

        $(document).on('click', '.shared-block .tel-share', function (e) {
            e.preventDefault();
            openWin(tel);
        });

        $(document).on('click', '.shared-block .goog-share', function (e) {
            e.preventDefault();
            openWin(goog);
        });
        $(document).on('click', '.shared-block .ln-share', function (e) {
            e.preventDefault();
            openWin(ln);
        });
        $(document).on('click', '.shared-block .ok-share', function (e) {
            e.preventDefault();
            openWin(ok);
        });

        $(document).on('click', '.shared-block', function (e) {
            e.preventDefault();
        });
    })
})(jQuery)